import { userHasRole } from "../utils/policyUtils.js";

export default {
  viewAny: ({ user, claim }) => {
    // check if user kunde_id_ov matches claim kunde_id_ov
    if (
      userHasRole(user,
        ["sysadmin", "makler_sachbearbeitung", "makler_buchhaltung"] &&
        user.kunde_id_ov &&
        claim.kunde_id_ov &&
        user.kunde_id_ov === claim.kunde_id_ov
      )
    ) {
      return true;
    }

    return false;
  },
};
